<template>
    <div>
        <img :src="realData.img" :class="imgClass" />
        <div :class="titleClass">{{realData.name}}</div>
    </div>
</template>

<script>

import {ref, onMounted, watch } from "vue";

export default {
  name: 'App',
  components: {
  },
  props: {
    start: Boolean,
    data: Object,
  },
  setup(props) {
        watch(
        () => props.start,
            (newProps) => {
                console.log(newProps);//查看新值
                if (newProps == true) {
                    changeAnimes()
                } else {
                    imgClass.value = 'start_logoImg'
                    titleClass.value = 'start_title'
                }
                
            },
        () => props.data,
            (newProps) => {
                realData.value = newProps
            }
        );
    onMounted(() => {
        realData.value = props.data
    });

    const imgClass = ref('start_logoImg')
    const titleClass = ref('start_title')
    const realData = ref({})

    const startAnime = ref(false)
    const changeAnimes = () =>{
        let time = realData.value.index * 100;
        setTimeout(() => {
            imgClass.value = 'logoImg'
            titleClass.value = 'title'
        }, time);
    }
    return {
        imgClass,
        titleClass,
        startAnime,
        changeAnimes,
        realData
    };
  },
}
</script>

<style lang="less" scoped>
@keyframes logoAnime {
    from  {
      transform: translate(0px, -20px);
      opacity: 0;
      }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.logoImg{
    width: 100px;
    height: 100px;
    object-fit: contain;
    opacity: 1;
    animation-name: logoAnime;
    animation-duration: 1s;
    animation-timing-function:ease-in-out;
}

.start_logoImg{
    width: 100px;
    height: 100px;
    object-fit: contain;
    opacity: 0;
}
@keyframes titleAnime {
    from  {
      opacity: 0;
      }
  to {
      opacity: 1;
  }
}
.title{
    font-size: 25px;
    font-family: MicrosoftYaHeiLight;
    color: #333333;
    opacity: 1;
    animation-name: titleAnime;
    animation-duration: 1s;
    animation-timing-function:ease-in-out;
}

.start_title{
    font-size: 25px;
    font-family: MicrosoftYaHeiLight;
    color: #333333;
    opacity: 0;
}
</style>
